// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PatientCommsOverlay from './view'

export default function PatientCommsOverlayFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PatientComms/PatientCommsOverlay">
      <PatientCommsOverlay {...props}>
        {children}
      </PatientCommsOverlay>
    </Flow>
  )
}
